export default function useTestInterview() {
  async function isTest(vacancyId) {
    const { isDemo } = await this.$store.dispatch('vacancy/checkIfDemoVacancy', vacancyId);
    return isDemo;
  }

  return {
    isTest,
  };
}
